module.exports = __webpack_public_path__ + "img/0010.350af92c.jpg";